import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import CastingCommon    from '@utils/casting-common';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftCheck extends React.Component {
  render() {
    let detail = this.props.detail;
    let request_action = CastingCommon.getRequestAction(this.props.base, this.props.detail.insta_user_id, 'full_task');
    
    // アクション
    if( request_action == 'draft_check' ){
      let _html = null;
      
      this.props.base.check_draft.map((d, key) => {
        if( d.insta_user_id != detail.insta_user_id ) return null;
        _html = (
          <a href={'/draft/'+ d.unique_id} target="_blank">
            <li>
              {this.props.button}
            </li>
          </a>
        );
      });
      
      if( _html != null ) return _html;
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>下書きの確認依頼がありません</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftCheck;